<template>
	<div class="card">
		<div class="card-body">
			<div class="row align-items-center">
				<div class="col-md-2 col-6">
					<base-input label="วันที่">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="ถึง">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-">
					<base-input label="ค้นหา" placeholder="ค้นหา ..." v-model="searchText" />
				</div>
				<div class="col-md-6 col-12 search">
					<base-button type="default" @click="getMembers()" :disabled="loading">
						ค้นหา
					</base-button>
				</div>
			</div>

			<div class="mt-4">
				<member-list-table
					:data="members"
					@updateStatus="updateStatus"
					@editMember="editMember"
					@addCredit="addCredit"
					@viewDeposit="viewDeposit"
					@viewWithdraw="viewWithdraw"
					@viewOther="viewOther"
				/>
			</div>
		</div>

		<!-- Tx table modal -->
		<tx-table-modal
			:open="viewTxTableModal[0]"
			:type="viewTxTableModal[1]"
			@close="viewTxTableModal = [false, false]"
		/>

		<!-- Edit member modal -->
		<edit-member-modal
			:open="!!viewEditMember"
			:memberInfo="viewEditMember"
			@close="viewEditMember = null"
			@reloadMember="getMembers"
		/>

		<!-- Add credit modal -->
		<add-credit-modal
			:open="!!viewAddCredit"
			:member="viewAddCredit"
			@close="viewAddCredit = null"
			@reloadMember="getMembers"
		/>
	</div>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import MemberListTable from '../backend-components/Member/MemberListTable'
import TxTableModal from '../backend-components/Member/TxTableModal'
import EditMemberModal from '../backend-components/Member/EditMemberModal'
import AddCreditModal from '../backend-components/Member/AddCreditModal'

import MemberService from '../services/member.service'
import moment from 'moment'

export default {
	components: {
		flatPicker,
		MemberListTable,
		TxTableModal,
		EditMemberModal,
		AddCreditModal,
	},
	data() {
		return {
			loading: false,

			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
			searchText: this.$route.query.search,

			members: [],
			viewEditMember: null,
			viewAddCredit: null,
			viewTxTableModal: [false, false],
		}
	},
	methods: {
		getMembers() {
			this.loading = true
			MemberService.getMembers({
				start: this.startDate,
				end: this.endDate,
				search: this.searchText,
			})
				.then((res) => {
					this.members = res
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
				.finally(() => {
					this.loading = false
				})
		},
		updateStatus(member) {
			this.loading = true
			MemberService.updateStatus(member.id, {
				status: member.status ? false : true,
			})
				.then(({ message }) => {
					this.$notify({ type: 'success', message })

					this.getMembers()
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
				.finally(() => {
					this.loading = false
				})
		},
		editMember(member) {
			this.viewEditMember = member
		},
		addCredit(member) {
			this.viewAddCredit = member
		},
		viewDeposit(memberID) {
			this.viewTxTableModal = [memberID, 'deposit']
		},
		viewWithdraw(memberID) {
			this.viewTxTableModal = [memberID, 'withdraw']
		},
		viewOther(memberID) {
			this.viewTxTableModal = [memberID, 'other']
		},
	},
	created() {
		this.getMembers()
	},
}
</script>
